import React, { useState, useEffect } from 'react';
import "./stylesheets/Foras.css";
import JobBanner from './components/JobBanner';
import ForasTag from './components/ForasTag';
import { BACKEND } from '../config';
import axios from 'axios';
import { Buffer } from 'buffer';
import { calculateTimeAgo } from '../utils/JobUtils';
import { FaArrowAltCircleLeft } from 'react-icons/fa';
import { useUser } from '../hooks/useUser.js';
import RestartAltIcon from '@mui/icons-material/RestartAlt'

const searchLimit = 20;

export default function Foras() {
  const curUser = useUser()

  const [activeTags, setActiveTags] = useState([]);
  const [categories, setCategories] = useState([]);
  const [jobTypes, setJobTypes] = useState([])

  const [selectedCategories, setSelectedCategories] = useState(new Set());
  const [selectedJobTypes, setSelectedJobTypes] = useState(new Set());
  const [excludeApplied, setExcludeApplied] = useState(true)

  const [jobs, setJobs] = useState([]);
  const [savedJobIDs, setSavedJobIDs] = useState(new Set())
  const [latestQueryParams, setLatestQueryParams] = useState()
  const [moreAvailable, setMoreAvailable] = useState(false)

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // const handleClickTag = (index) => {
  //   if (activeTags.includes(index)) {
  //     setActiveTags(activeTags.filter((item) => item !== index));
  //   } else {
  //     setActiveTags([...activeTags, index]);
  //   }
  // };

  const fetchOptions = () => {
    if (categories.length > 0) {
      return;
    }
    axios.get(`/categories/`, { params: { getTypes: true } })
      .then(result => {
        setCategories(result.data?.categories);
        setJobTypes(result.data?.jobTypes)
      }).catch(error => {
        console.log(error);
        setCategories([]);
      });
  };

  const generateCategoryList = () => {
    return categories.map((option) => (
      <label key={option._id} className="radio-label" style={{ marginBottom: '5%' }}>
        <input
          type="checkbox"
          name="category"
          value={option._id}
          checked={selectedCategories.has(option._id)}
          onChange={handleCategoryChange}
        />
        {option.name}
      </label>
    ));
  };

  const generateJobTypeList = () => {
    const queue = Object.entries(jobTypes);

    // Check if there are at least 3 elements before reordering
    if (queue.length >= 3) {
      const thirdOption = queue.splice(2, 1)[0]; // Remove the 3rd option
      queue.unshift(thirdOption); // Insert it at the front of the queue
    }

    return queue.map(([value, label]) => (
      <label key={value} className="radio-label" style={{ marginBottom: '5%' }}>
        <input
          type="checkbox"
          value={value}
          name='jobType'
          checked={selectedJobTypes.has(value)}
          onChange={handleJobTypeChange}
        />
        {label}
      </label>
    ));
  };


  const handleClickTag = (index) => {
    setActiveTags((prevTags) => {
      if (prevTags.includes(index)) {
        return prevTags.filter(tagIndex => tagIndex !== index);
      } else {
        return [...prevTags, index];
      }
    });
  };


  const generateTags = () => {
    if (selectedCategoryTags.length === 0) {
      return Array.from({ length: 5 }).map((_, index) => (
        <label key={index} id="tag-label" style={{ color: '#00000060' }}>
          <input
            type="checkbox"
            disabled
          />
          Choose Category
        </label>
      ));
    }

    return selectedCategoryTags.map((button, index) => (
      <label key={index} id="tag-label" style={{ width: '100%', textWrap: 'nowrap' }}>
        <input
          type="checkbox"
          checked={activeTags.includes(index)}
          onChange={() => handleClickTag(index)}
        />
        {button}
      </label>
    ));
  };



  const handleCategoryChange = (event) => {
    setSelectedCategories(prev => {
      const updated = new Set(prev);
      updated.has(event.target.value) ? updated.delete(event.target.value) : updated.add(event.target.value)
      return updated
    });
    setActiveTags([]);
  };

  const handleJobTypeChange = (event) => {
    setSelectedJobTypes(prev => {
      const updated = new Set(prev)
      if (updated.has(event.target.value)) {
        updated.delete(event.target.value);
      } else {
        updated.add(event.target.value);
      }
      return updated
    });
  };

  const selectedCategoryTags = categories.filter((option) => selectedCategories.has(option._id)).map((option) => option.tags).flat();
  console.log( categories.filter((option) => selectedCategories.has(option._id)).map((option) => option.tags).flat())

  const search = (reset = false) => {
    let q = document.getElementById('search').value;
    let cat = reset ? [] : Array.from(selectedCategories);
    let tags = (reset ? [] : selectedCategoryTags).filter((e, i) => activeTags.includes(i));
    let types = Array.from(reset ? new Set() : selectedJobTypes)

    const queryParams = {
      q,
      excludeApplied,
      limit: searchLimit,
    };


    if (tags.length > 0) {
      let json = JSON.stringify(tags);
      let enc = Buffer.from(json).toString('base64');
      enc = enc.replace(/[+/=]/g, function (match) {
        return match === '+' ? '-' : match === '/' ? '_' : '';
      });
      queryParams.tags = enc;
    }
    if (types.length > 0) {
      let json = JSON.stringify(types);
      let enc = Buffer.from(json).toString('base64');
      enc = enc.replace(/[+/=]/g, function (match) {
        return match === '+' ? '-' : match === '/' ? '_' : '';
      });
      queryParams.types = enc;
    }
    if (cat.length > 0) {
      let json = JSON.stringify(cat);
      let enc = Buffer.from(json).toString('base64');
      enc = enc.replace(/[+/=]/g, function (match) {
        return match === '+' ? '-' : match === '/' ? '_' : '';
      });
      queryParams.cat = enc;
    }

    axios.get(`/jobs/search`, { params: queryParams })
      .then(result => {
        setJobs(result.data);
        setLatestQueryParams(queryParams)
        setMoreAvailable(result.data.length === searchLimit)
      })
      .catch(err => {
        console.log(err);
        setJobs([]);
      });
  };

  const getSavedJobs = () => {
    if (!curUser.id) {
      return;
    }

    axios.get('/users/savedJobs').then(result => {
      setSavedJobIDs(new Set(result.data?.savedJobs))
    }).catch(err => {
      setSavedJobIDs(new Set())
      console.log(err);
    })
  }

  const loadMore = () => {
    if (!latestQueryParams) return search();

    const queryParams = { ...latestQueryParams }
    const latestJob = jobs?.at(-1)
    if (queryParams.q?.length > 0) {
      queryParams.searchAfter = latestJob?.paginationToken
    } else {
      queryParams.queryCursor = latestJob?.createdAt
    }

    axios.get(`/jobs/search`, { params: queryParams })
      .then(result => {
        setJobs(prev => [...prev, ...result.data]);
        setMoreAvailable(result.data.length === searchLimit)
      })
      .catch(err => {
        console.log(err);
        setJobs([]);
      });
  }

  const generateJobCards = () => {
    return jobs.map(job => {
      return <JobBanner
        key={job._id}
        job={job}
        saved={savedJobIDs.has(job._id)}
        setSavedJobIDs={setSavedJobIDs}
        jobTypes={jobTypes}
      />;
    });
  };

  const handleReset = () => {
    setSelectedCategories(new Set());
    setActiveTags([]);
    document.getElementById('search').value = '';
    setSelectedJobTypes(new Set());

    search(true);
  };

  useEffect(() => {
    fetchOptions();
    search();
    getSavedJobs();
  }, []);

  return (
    <div className='ForasPage'>

      <div className='SearchForsa'>
        {
          windowWidth > 1024 ?
            <div id='FilterArea'>
              <h4 style={{ color: 'black', fontSize: '2.25svh', fontWeight: 700 }}>Filters</h4>
              <a onClick={handleReset} style={{ color: 'black', fontSize: '2.25svh', fontWeight: 700, cursor: 'pointer' }}>
                <RestartAltIcon />
              </a>
            </div>
            :
            <div> </div>
        }
        <input id='search' type="search" onKeyDown={(e) => { if (e.key === 'Enter') { search() } }} placeholder=' Search' />

        {curUser.id &&
          <div id='CategoryArea' style={{ marginTop: '2.5%' }}>
            <label style={{ fontSize: '12px', alignItems: 'center', display: 'flex' }}>
              <input type='checkbox' checked={excludeApplied} onChange={e => setExcludeApplied(e.target.checked)} />
              Exclude jobs already applied to
            </label>
          </div>
        }
        <div id='CategoryArea' style={{}}>
          <h4 className='CategoryTitle' style={{ fontWeight: 'bold', color: 'black' }}>Job Type</h4>
          {/* TODO The new options added in foras */}
          <form style={{ display: 'flex', flexDirection: 'column', width: '100%', marginBottom: 0 }} id='generateOptions'>
            {generateJobTypeList()}
          </form>
        </div>

        <div id='CategoryArea'>
          <h4 className='CategoryTitle' style={{ fontWeight: 'bold', color: 'black' }}>Job Category</h4>
          <form style={{ display: 'flex', flexDirection: 'column', width: '100%' }} id='generateOptions' onFocus={fetchOptions}>
            {generateCategoryList()}
          </form>
        </div>
        {/* <div id='CategoryArea'>
          <h4 style={{ fontWeight: 'bold', color: 'black' }}>Job Tags</h4>
          <div className='displayTopicsSection'>
            {generateTags()}
          </div>
          </div> */}

        <button onClick={() => search()} style={{ width: '80%', borderRadius: 5, padding: 10, alignSelf: 'center', marginBottom: '5%', marginLeft: windowWidth > 1024 ? '' : '7.5%' }}>Filter</button>

      </div>


      <div className="JobDisplaySection">
        <div className='rightSide'>
          {generateJobCards()}
        </div>
        <div id='LoadMoreArea'>
          {moreAvailable && <button id='LoadMoreButton' onClick={loadMore}>Load More</button>}
        </div>
      </div>
    </div>
  );
}
